import React from 'react';
import PropTypes from 'prop-types';

import { BuildingPicker, ChangeDetector, withTranslation } from '../../common';

function FormFieldBuilding({
  values,
  update,
  field,
  isSubmitted,
  detectChanges,
  translate,
  ...otherProps
}) {
  const updateValue = building => {
    update(field, building);
  };

  const labelText = translate(`changeRequests.fieldNames.${field}`);

  const invalid = isSubmitted && !values.new;

  return (
    <div className="ChangeRequestFormField">
      <ChangeDetector values={values} invalid={invalid} detectChanges={detectChanges}>
        <label htmlFor={field}>{labelText}</label>
        <BuildingPicker
          id={field}
          label={labelText}
          building={values.new}
          updateBuilding={updateValue}
          invalid={invalid}
          required
          {...otherProps}
        />
      </ChangeDetector>
    </div>
  );
}

const buildingPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
});

FormFieldBuilding.propTypes = {
  values: PropTypes.shape({
    old: buildingPropType,
    new: buildingPropType
  }).isRequired,
  field: PropTypes.string.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
  detectChanges: PropTypes.bool,
  translate: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired
};

FormFieldBuilding.defaultProps = {
  detectChanges: true
};

export default withTranslation(FormFieldBuilding);
